export { default as plain } from './plain';
export { default as _1324 } from './_1324';
export { default as _1326 } from './_1326';
export { default as _135 } from './_135';
export { default as martingale } from './martingale';
export { default as supermartingale } from './supermartingale';
export const dict = [
    { label: "ไม่ทบ", module: "plain", note: "เท่ากันทุกตา", free: true, default: true },
    { label: "1-3-2-4", module: "_1324", note: "แนะนำ [VIP]", default: true },
    { label: "1-3-2-6", module: "_1326", note: "[VIP]" },
    { label: "มาติงเกล", module: "martingale", note: "ใช้อย่างระมัดระวัง", free: true },
    { label: "ซูเปอร์มาติงเกล", module: "supermartingale", note: "ใช้อย่างระมัดระวัง", free: true },
]
